import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormControl, FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Observable } from 'rxjs';
import { NewJobService } from '../app-service/newJob.service';
import { SharedService } from '../app-service/shared.service';
import { newJob } from '../model/newJob';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { QrCodeReaderComponent } from '../qr-code-reader/qr-code-reader.component';
@Component({
  selector: 'app-new-entry-scanner',
  templateUrl: './new-entry-scanner.component.html',
  styleUrls: ['./new-entry-scanner.component.css'],
})

export class NewEntryScannerComponent implements OnInit {
  form: FormGroup;
  array: any[3] = [];
  MVA: any = '';
  REGO: any = '';
  model: any = '';
  km: any = '';
  vin: any = '';
  employeeName: string;
  wwid: number;
  newStartTime: any;
  users: any;
  MVAInfo: any = [];
  result: any;
  //object is created for newJob class
  newjobObjfromNewEntryCompo: newJob;
  PMSegmentList: any = [];
  defaultServiceRange: any;
  RepairOrderPMSegmentList: any;
  isKmsInRange: any = true;
  //to console start time
  starttime: any;
  // To print the start time in console
  interval: any;
  selectoption: string = 'PM';
  selectedCategory: string;
  selectedRange: any;
  value = 'PM';
  backimg: string = "assets/images/back.png";
  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Origin,X-Requested-With,Content-Type,Accept,GET',
      'Access-Control-Allow-Methods': 'GET',
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    public dialogRef: MatDialogRef<NewEntryScannerComponent>,
    private http: HttpClient,
    private router: Router, public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private newJobService: NewJobService,
    private sharedService: SharedService
  ) {
    // to Disable click outside of dialog box
    dialogRef.disableClose = true;
    this.newjobObjfromNewEntryCompo = {
      wwid: 0,
      employeeName: '',
      MVA: '',
      REGO: '',
      model: '',
      km: '',
      starttime: '',
      endtime: '',
      status: false,
      radiobutton: '',
      RepairOrderId: 0,
      country: '',
      state: '',
      VIN_NO:'',
      pm: {
        RepairOrderId: 0,
        exteriorlights: false,
        instrumentalsandcontrolsoperation: false,
        parkbrakeoperation: false,
        engineoil: false,
        oilfilter: false,
        underbodyforleaks: false,
        tyresforweartear: false,
        TyreDepth: false,
        TLFH: '',
        TLHR: '',
        TRHF: '',
        TRHR: '',
        TSPARE: '',
        brakepadsdepth: false,
        NumberOfTyreUsed: '',
        BLFH: '',
        BLHR: '',
        BRHF: '',
        BRHR: '',
        BSPARE: false,
        INSP_BRAKE_PADS_DEPTH:false,
        enginecompartmentforleakagewearanddamage: false,
        airfilter: false,
        fuelfliters: false,
        pollenfilter: false,
        underbonnetfluids: false,
        recordandstampservice: false,
        checkforholds: false,
        updatewizard: false,
        Comments: '',
        AIR_FILTER_REPLACED: false,
        POLLEN_FILTER_REPLACED: false,
        BRAKE_PAD_DEPTH_REPLACED: false,
        oilsupplier: '',
        supplier: '',
        tyre: '',
        VendorName: '',
        CostOfTyre: 0,
        ServiceRange:'',
        ServiceMinutes:0,
        Weight:0
      },
      tyre: {
        supplier: '',
        tyre: '',
        other: '',
        NumberOfTyre: 0,
        VendorName: '',
        CostOfTyre: 0,
      },
      sublet: {
        supplier: '',
        cost: 0,
        executePMP:false,
        ponumber:0,
        invoicenumber: 0,
        kilometres: 0,
        workcarriedout: '',
        comments: '',
        SubletDate: ''
      },
      handbackbuyback:{
        ServeBook:false,
        OWNER_MAN:false,
        PRIMARY_AND_SPARE:false,
        TOOLS_BRACE_JACK:false,
        SD_CARD:false,
        ANY_OTHER_ACCESSORIES:false,
        GLASS_FREE_DEFECTS_DRIVERS_VISION:false,
        TYRES_MATCHING_AXLE_:false,
        WHEEL_RIMs_SCRAP:false,
        WHEEL_TRIMs_SCRAP:false,
        LIGHT_REFLECTORS_STATE:false,
        CARPET_RIPPED_HEEL_PADS:false,
        INTERIOR_NO_MORE:false,
        PAINT_TO_PANEL:false,
        NZ_VEHICLE_REGISTERED:false,
        NZ_VEHICLE_CURRENT_COF:false,
       COMMENT:'',
      },
      other: {
        COMMENT: '',
      },
      timearray: [],
    } as newJob;
  }

  createForm() {
    this.form = this.formBuilder.group({
      wwid: new FormControl(0, Validators.required),
      employeeName: new FormControl('', Validators.required),
      MVA: new FormControl(''),
      REGO: new FormControl(''),
      model: new FormControl(''),
      km: new FormControl(''),
    });
  }
  d = true
  ngOnInit() {
    this.createForm();
    //wwid=10010
    this.wwid = this.sharedService.userData.wwid;
    this.employeeName = this.sharedService.userData.employeeName;
    if(this.km >= 0 && this.km < 15000)
    {
      this.defaultServiceRange = this.PMSegmentList[0];
    }
    else if(this.km >= 15000 && this.km < 45000)
    {
      this.defaultServiceRange = this.PMSegmentList[1];
    }
    else if(this.km >= 45000 && this.km < 60000)
    {
      this.defaultServiceRange = this.PMSegmentList[2];
    }
    else if(this.km >= 60000 && this.km < 80000)
    {
      this.defaultServiceRange = this.PMSegmentList[3];
    }
    else
    {
      this.defaultServiceRange = this.PMSegmentList[4];
    }
    // this.wwid=10010
    // this.employeeName='TNikita-ext'

  }

  fetchData() {
    if (this.selectoption.toLocaleLowerCase() === 'ferry' || this.selectoption.toLocaleLowerCase() === 'other') {
      //this.d=false
      if (this.MVA != '') {
        let mva = this.newJobService.getByMVA(this.MVA); //this.http.get(url);
        mva.subscribe(
          (mvadata: any) => {
            this.MVAInfo = mvadata;
            if (this.MVAInfo.Model.MVA_NO != null) {
              //console.log(mvadata);
              //pass this mvadata when continue click on shared service and in select feature it will take mvadata from shared service
              this.sharedService.getMVAData(mvadata as newJob);
              this.MVA = this.MVAInfo.Model.MVA_NO;
              this.REGO = this.MVAInfo.Model.REG_NO;
              this.model = this.MVAInfo.Model.VEH_DESC;
              this.km = this.MVAInfo.Model.KMS;
              this.vin = this.MVAInfo.Model.VIN_NO;
            } else {
              //console.log('MVA not found');
              this.REGO = '';
              this.model = '';
              this.km = '';
            }
          },
          (error) => console.log('Enter MVA ID')
        );
      }

    }
    else {
      //console.log(this.MVA);
      
      if (this.MVA != '') {
        let mva = this.newJobService.getByMVA(this.MVA); //this.http.get(url);
        mva.subscribe(
          (mvadata: any) => {
            this.MVAInfo = mvadata;
            if (this.MVAInfo.Model.MVA_NO != null) {
              //console.log(mvadata);
              //pass this mvadata when continue click on shared service and in select feature it will take mvadata from shared service
              this.sharedService.getMVAData(mvadata as newJob);
              this.MVA = this.MVAInfo.Model.MVA_NO;
              this.REGO = this.MVAInfo.Model.REG_NO;
              this.model = this.MVAInfo.Model.VEH_DESC;
              this.km = this.MVAInfo.Model.KMS;
              this.vin = this.MVAInfo.Model.VIN_NO;
              this.form.get('km')?.setValue('');
              const kms = Number(this.km);
              if(kms >= 0 && kms < 15000)
              {
                this.defaultServiceRange = this.PMSegmentList[0];
              }
              else if(kms >= 15000 && kms < 45000)
              {
                this.defaultServiceRange = this.PMSegmentList[1];
              }
              else if(kms >= 45000 && kms < 60000)
              {
                this.defaultServiceRange = this.PMSegmentList[2];
              }
              else if(this.km >= 60000 && this.km < 80000)
              {
                this.defaultServiceRange = this.PMSegmentList[3];
              }
              else
              {
                this.defaultServiceRange = this.PMSegmentList[4];
              }
            } else {
              // console.log('MVA not found');
              this.REGO = '';
              this.model = '';
              this.km = '';
              this.form.get('km')?.setValue('');
            }
          },
          (error) => console.log('Enter MVA ID')
        );
      }
      else {
        console.log('Enter MVA ID');
      }
      
    }
  }
  fetchDataUsingRego() {
    console.log(this.REGO)
    // if (this.selectoption.toLocaleLowerCase() === 'ferry' || this.selectoption.toLocaleLowerCase() === 'other') {
      //this.d=false
      if (this.REGO != '') {
        let rego = this.newJobService.getByMVA(this.REGO); //this.http.get(url);
        console.log(rego)
        rego.subscribe(
          (mvadata: any) => {
            // this.MVAInfo = mvadata;
            this.MVA = mvadata.Model.MVA_NO;
            this.fetchData()
          }
        );
      }
    // }
  }

  hr = ('0' + new Date().getHours()).slice(-2);
  minit = ('0' + new Date().getMinutes()).slice(-2);
  second = ('0' + new Date().getSeconds()).slice(-2);
  startTimer() {
    localStorage.setItem("showWorkCompleted","false") ;
    localStorage.setItem("showWorkInProgress","true") ;
    this.sharedService.getSelectedOption(this.selectoption);
    this.newStartTime = new Date().toISOString();
    //console.log(this.newStartTime);
    this.sharedService.savenewST(this.newStartTime);
    this.starttime = this.hr + ':' + this.minit + ':' + this.second;
    //console.log(this.hr + ':' + this.minit + ':' + this.second);

    //console.log(this.form.value);
    this.newjobObjfromNewEntryCompo.MVA = this.MVA;
    this.newjobObjfromNewEntryCompo.REGO = this.REGO;
    this.newjobObjfromNewEntryCompo.VIN_NO = this.vin;
    this.newjobObjfromNewEntryCompo.employeeName = this.employeeName;
    // if (this.km != '') {
    //   this.newjobObjfromNewEntryCompo.km = this.km.toString();
    // }
    const enteredKm = this.form.get('km')?.value;
    if (enteredKm !== '') {
      this.newjobObjfromNewEntryCompo.km = enteredKm.toString();
    } else {
      this.newjobObjfromNewEntryCompo.km = this.km.toString(); // fallback to original km (from fetch)
    }
    this.newjobObjfromNewEntryCompo.model = this.model;
    this.newjobObjfromNewEntryCompo.wwid = this.wwid;
    this.newjobObjfromNewEntryCompo.starttime = this.starttime;
    this.newjobObjfromNewEntryCompo.endtime = '00:00:00';
    //before dropdown changes
    //this.newjobObjfromNewEntryCompo.radiobutton=""

    //after dropdown changes
    this.newjobObjfromNewEntryCompo.radiobutton = this.selectoption
    this.array = { starttime: this.starttime, endtime: "00:00:00", clocktime: "00:00:00" }

    this.sharedService.saveStartTime(this.newjobObjfromNewEntryCompo.starttime);

    this.newJobService.storeJobIdOnNewService('0');
    this.sharedService.clockShow = true;
    this.newjobObjfromNewEntryCompo.timearray.push(this.array)
    //console.log(this.newjobObjfromNewEntryCompo);

    this.newjobObjfromNewEntryCompo.country = this.sharedService.usercountry;
    this.newjobObjfromNewEntryCompo.state = this.sharedService.userstate;
    let jsonObj = JSON.parse(localStorage.getItem('userDetails')!)
    this.newjobObjfromNewEntryCompo.country = jsonObj.country;
    this.newjobObjfromNewEntryCompo.state = jsonObj.state;
    if(this.selectedCategory === "PM")
    {
      this.newjobObjfromNewEntryCompo.pm.ServiceRange = this.defaultServiceRange;
      const selectedItem = this.RepairOrderPMSegmentList.find((item: { ServiceRange: any; }) => item.ServiceRange === this.defaultServiceRange);
      this.newjobObjfromNewEntryCompo.pm.ServiceMinutes = selectedItem.ServiceMinutes;
      this.newjobObjfromNewEntryCompo.pm.Weight = selectedItem.Weight;
    }
    

    //debugger
    //call below method to post data object
    this.saveData();
  }
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
  itemSelect(newVal: any) {

    //console.log(this.value=newVal);
    this.selectoption = newVal;
    //console.log(this.selectoption);
    if (this.selectoption.toLocaleLowerCase() === 'ferry' || this.selectoption.toLocaleLowerCase() === 'other') {
      this.d = false
    }
    else
    {
      this.d = true
    }
    if(this.selectoption.toLocaleLowerCase() === 'pm')
    {
      this.newJobService.GetRepairOrderPMSegmentList()
      .subscribe((data: any) => {
        if (data.Success) {
          const modelList = data.Model;
          this.RepairOrderPMSegmentList = data.Model;
          const serviceRangeList: string[] = modelList.map((item: { ServiceRange: any; }) => item.ServiceRange);
          this.PMSegmentList = serviceRangeList;
        } 
      });
    }

  }
  

  saveData() {
   
    //we will post object and taking response of data.success if it is true then and then only object will pass shared service
    //this.newjobObjfromNewEntryCompo.RepairOrderId=264;
    this.newJobService.postData(this.newjobObjfromNewEntryCompo)
      .subscribe((data: any) => {
        // this.newjobObjfromNewEntryCompo.RepairOrderId=22;
        //console.log(data.Success);

        if (data.Success) {

          this.newjobObjfromNewEntryCompo.RepairOrderId = data.Model.repairJobid;
          this.sharedService.newScannerObjPassingOnSharedService(
            this.newjobObjfromNewEntryCompo
          );
          //console.log(this.newjobObjfromNewEntryCompo.RepairOrderId);

          //console.log(data.Model.repairJobid);

          this.toastr.success('Data Saved Successfully', '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-full-width'
          })
          // this.router.navigateByUrl('/selectFeature');
          this.redirectTo('/selectFeature');
        }
        else {
          this.toastr.warning('Data not Saved', '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-full-width'
          })
        }
      });
  }
  QRScanner() {
    // const dialogRef = this.dialog.open(QrCodeReaderComponent, {
    //   panelClass: 'app-dialog',
    // });
  }

  onClose(): void {
    this.dialogRef.close();
  }
  rangeSelect(newVal: any) {
    this.selectedRange = newVal;
    let actualServiceRange: any;
    if(this.km >= 0 && this.km < 15000)
    {
      actualServiceRange = this.PMSegmentList[0];
    }
    else if(this.km >= 15000 && this.km < 45000)
    {
      actualServiceRange = this.PMSegmentList[1];
    }
    else if(this.km >= 45000 && this.km < 60000)
    {
      actualServiceRange = this.PMSegmentList[2];
    }
    else if(this.km >= 60000 && this.km < 80000)
    {
      actualServiceRange = this.PMSegmentList[3];
    }
    else
    {
      actualServiceRange = this.PMSegmentList[4];
    }
    if(this.selectedRange != actualServiceRange)
    {
      this.isKmsInRange = false;
      this.toastr.warning('Please update KMS according to selected service range', '', {
            timeOut: 2000,
            positionClass: 'toast-bottom-full-width'
          })
    }
    else
    {
      this.isKmsInRange = true;
    }
  }

  //old Logic - Added (input)="kmsChange($any($event.target).value)" in html for KMS
  // kmsChange(val:any){
  //   this.form.get('km')?.setValue(val);
  //   if(this.selectedCategory === "PM")
  //   {
  //     let ChangedServiceRange;
  //     //this.km = Number(val)

  //     if(Number(val) >= 0 && Number(val) < 15000)
  //     {
  //       ChangedServiceRange = this.PMSegmentList[0];
  //     }
  //     else if(Number(val) >= 15000 && Number(val) < 45000)
  //     {
  //       ChangedServiceRange = this.PMSegmentList[1];
  //     }
  //     else if(Number(val) >= 45000 && Number(val) < 60000)
  //     {
  //       ChangedServiceRange = this.PMSegmentList[2];
  //     }
  //     else if(Number(val) >= 60000 && Number(val) < 80000)
  //     {
  //       ChangedServiceRange = this.PMSegmentList[3];
  //     }
  //     else
  //     {
  //       ChangedServiceRange = this.PMSegmentList[4];
  //     }
  //     if(this.defaultServiceRange != ChangedServiceRange)
  //     {
  //       this.isKmsInRange = false;
  //       this.toastr.warning('Please update KMS according to selected service range', '', {
  //             timeOut: 2000,
  //             positionClass: 'toast-bottom-full-width'
  //           })
  //     }
  //     else
  //     {
  //       this.isKmsInRange = true;
  //     }
  //   }
    
  // }
  updateServiceRangeOnKmBlur() {
    if (this.selectedCategory !== 'PM') return;

    const enteredKm = Number(this.form.get('km')?.value);
    if (isNaN(enteredKm)) return; // ignore invalid inputs

    let newRange: string;

    if (enteredKm >= 0 && enteredKm < 15000) {
      newRange = this.PMSegmentList[0];
    } else if (enteredKm >= 15000 && enteredKm < 45000) {
      newRange = this.PMSegmentList[1];
    } else if (enteredKm >= 45000 && enteredKm < 60000) {
      newRange = this.PMSegmentList[2];
    } else if (enteredKm >= 60000 && enteredKm < 80000) {
      newRange = this.PMSegmentList[3];
    } else {
      newRange = this.PMSegmentList[4];
    }

    // Only update if changed to avoid redundant updates
    if (this.defaultServiceRange !== newRange) {
      this.defaultServiceRange = newRange;
      this.isKmsInRange = true;
    }
  }
}
